var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2375_14129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1876 83.4015C72.497 81.144 81.1407 72.502 83.3982 64.1909C84.668 59.0947 85.9765 52.2685 86 43C85.9765 33.7348 84.668 26.9086 83.3982 21.8124C81.1407 13.503 72.4987 4.85933 64.1876 2.60183C59.0931 1.33199 52.2652 0.0235141 43 -1.87959e-06C33.7332 0.0235133 26.9069 1.33199 21.8107 2.60183C13.4996 4.85933 4.85766 13.503 2.60016 21.8124C1.33031 26.9086 0.0218339 33.7382 -1.87966e-06 43.0017C0.021833 52.2668 1.33031 59.0947 2.60016 64.1909C4.85766 72.502 13.4996 81.144 21.8107 83.4015C26.9069 84.6713 33.7365 85.9798 43 86.0016C52.2652 85.9798 59.0914 84.6713 64.1876 83.4015Z",
    fill: "#E5F4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1288 42.1302C19.0062 40.1787 20.4288 38.5222 22.2253 37.3601C24.0219 36.1979 26.116 35.5796 28.2556 35.5794L44.6595 35.5794L44.6595 39.3923C44.6595 41.7925 47.268 43.8619 49.3727 42.8272C55.5035 39.792 61.7116 35.3694 67.8106 31.5548C68.2892 31.2635 68.6848 30.8539 68.9592 30.3654C69.2337 29.8769 69.3779 29.326 69.3779 28.7657C69.3779 28.2054 69.2337 27.6545 68.9592 27.1661C68.6848 26.6776 68.2892 26.268 67.8106 25.9766C61.7116 22.162 55.5035 17.7461 49.3727 14.7042C47.268 13.6695 44.6578 15.7406 44.6595 18.1392L44.6595 21.942L28.2607 21.942C25.1735 21.942 22.2127 23.1684 20.0298 25.3513C17.8468 27.5343 16.6204 30.495 16.6204 33.5822L16.6204 41.8043C16.6205 41.9847 16.6823 42.1596 16.7956 42.2999C16.9089 42.4402 17.0669 42.5375 17.2432 42.5756C17.4195 42.6137 17.6035 42.5903 17.7646 42.5092C17.9257 42.4282 18.0543 42.2944 18.1288 42.1302Z",
    fill: "url(#paint0_linear_2375_14129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8695 43.8716C66.992 45.8231 65.5695 47.4796 63.7729 48.6417C61.9764 49.8039 59.8823 50.4222 57.7426 50.4224L41.3388 50.4224L41.3388 46.6095C41.3388 44.2093 38.7302 42.1399 36.6256 43.1746C30.4947 46.2098 24.2866 50.6324 18.1876 54.4469C17.709 54.7383 17.3135 55.1479 17.039 55.6364C16.7645 56.1249 16.6203 56.6758 16.6203 57.2361C16.6203 57.7964 16.7645 58.3473 17.039 58.8357C17.3135 59.3242 17.709 59.7338 18.1876 60.0252C24.2866 63.8398 30.4947 68.2557 36.6256 71.2976C38.7302 72.3323 41.3405 70.2612 41.3388 67.8626L41.3388 64.0581L57.7376 64.0581C60.8236 64.0563 63.7826 62.8292 65.9641 60.6464C68.1456 58.4636 69.3711 55.5039 69.3711 52.4179L69.3711 44.1958C69.3675 44.0182 69.304 43.847 69.191 43.7098C69.078 43.5727 68.9221 43.4777 68.7484 43.4402C68.5747 43.4028 68.3935 43.4249 68.234 43.5032C68.0745 43.5815 67.946 43.7113 67.8695 43.8716Z",
    fill: "url(#paint1_linear_2375_14129)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2375_14129",
    x1: 23.4584,
    y1: 48.9782,
    x2: 59.1804,
    y2: 13.2563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2375_14129",
    x1: 28.5513,
    y1: 70.4997,
    x2: 68.2658,
    y2: 32.3255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF4B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2375_14129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white",
    transform: "translate(86) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconConvert);
export default __webpack_public_path__ + "static/media/common_icon_convert.bd6309a58939e8b556b5ca2eabd51e5f.svg";
export { ForwardRef as ReactComponent };